<template>
  <div class="row mt-4">
    <div class="col-7 text-uppercase">
      <h4><b>Enviar mensagens com arquivos no WhatsApp</b></h4>
    </div>

    <div class="col-5">
      <b-row 
        class="align-items-center border-r5 p-2 pointer mt-4" 
        style="border: 1px dashed #28a745; background-color: #eee; width:100%"
      >
        <b-col cols="10">
          <input type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="handleFileUpload">
        </b-col>
        <b-col class="text-right">
          <i class="fas fa-cloud-upload-alt fs-30 text-success"></i>
        </b-col>
      </b-row>
    </div>

    <div class="col-4 mt-4">
      <label>Tipo de envio</label>
      <select class="form-control" v-model="tipo">
        <option value="">-- Selecione --</option>
        <option value="1">Enviar somente texto</option>
        <option value="2">Enviar imagem com texto (Opcional)</option>
        <option value="3">Enviar PDF com texto (Opcional)</option>
        <option value="4">Enviar video com texto (Opcional)</option>
      </select>
    </div>

    <div class="col-2 mt-4">
      <label>ID WhatsApp</label>
      <input type="text" class="form-control" v-model="whatsapp_id" placeholder="Ex: 12">
    </div>

    <div class="col-6 mt-4">
      <label>Link do documento/imagem/vídeo</label>
      <input type="text" class="form-control" v-model="link" placeholder="link do arquivo feito upload na AWS">
    </div>

    <div class="col-12 mt-2">
      <label>Mensagem</label>
      <textarea class="form-control" v-model="mensagem" rows="4"></textarea>
    </div>

    <div class="col-12">
      <span style="color:red"><b>Foto (.png) / Vídeo (.mp4), outros formatos vai dar erro!</b></span>
    </div>

    <div class="col-12 mt-4">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th class="text-left">Número (numero)</th>
            <th class="text-left">Nome (nome) Opcional</th>
            <th class="text-left">Loja (loja) Opcional</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in numeros" :key="i">
            <td class="text-left">{{item.numero ? item.numero : '-'}}</td>
            <td class="text-left">{{item.nome ? item.nome : '-'}}</td>
            <td class="text-left">{{item.loja ? item.loja : '-'}}</td>
          </tr>
        </tbody>
      </table>

      <div class="row mb-4">
        <div class="col-12 text-center">
          <button class="btn btn-success pr-5 pl-5" :disabled="numeros.length == 0" @click="addNumeros()">Enviar WhatsApp</button>
        </div>
      </div>
    </div>

    <div class="col-12 mt-4">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="light">
              <h4><b>Enviados</b> ({{numerosEnviado.length}})</h4>
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <table class="table table-striped table-bordered" id="inseridos">
                <thead>
                  <tr>
                    <th class="text-left">Número</th>
                    <th class="text-left">Nome</th>
                    <th class="text-left">Loja</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in numerosEnviado" :key="i">
                    <td class="text-left">{{item.numero ? item.numero : '-'}}</td>
                    <td class="text-left">{{item.nome ? item.nome : '-'}}</td>
                    <td class="text-left">{{item.loja ? item.loja : '-'}}</td>
                  </tr>
                </tbody>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-2 variant="light">
              <h4><b>Não enviados</b> ({{numerosNaoEnviado.length}})</h4>
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <table class="table table-striped table-bordered" id="naoinseridos">
                <thead>
                  <tr>
                    <th class="text-left">Número</th>
                    <th class="text-left">Nome</th>
                    <th class="text-left">Loja</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in numerosNaoEnviado" :key="i">
                    <td class="text-left">{{item.numero ? item.numero : '-'}}</td>
                    <td class="text-left">{{item.nome ? item.nome : '-'}}</td>
                    <td class="text-left">{{item.loja ? item.loja : '-'}}</td>
                  </tr>
                </tbody>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>

  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import makeToast from '@/mixins/makeToast';
export default {
  name: 'EnviarWhatsappExcel',
  mixins: [makeToast],
  data() {
    return {
      tipo: '',
      link: '',
      whatsapp_id: '',
      mensagem: '',
      numeros: [],
      numerosEnviado: [],
      numerosNaoEnviado: []
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0]; // Assuming we have data in the first sheet
          const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          this.numeros = jsonData;
        };
        reader.readAsBinaryString(file);
      }
    },
    addNumeros() {
      if(this.tipo == '' || this.tipo == null) {
        this.makeToast('Oops', 'Informe o tipo de envio!', 'danger');
        return;
      }
      
      if(this.whatsapp_id == '' || this.whatsapp_id == null) {
        this.makeToast('Oops', 'Informe o ID WhatsApp!', 'danger');
        return;
      }

      if(this.tipo == '1' && this.mensagem == '') {
        this.makeToast('Oops', 'Informe a mensagem!', 'danger');
        return;
      }

      if(this.tipo != '1' && this.link == '') {
        this.makeToast('Oops', 'Informe o link do documento!', 'danger');
        return;
      }

      const numeros = this.numeros.slice(0, 5);

      const data = {
        tipo: this.tipo,
        link: this.link,
        whatsapp_id: this.whatsapp_id,
        mensagem: this.mensagem,
        numeros: numeros
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/sendWhatsappExcel', data)
        .then((response) => {
          if(response.data.numerosEnviado){
            if(this.numerosEnviado.length == 0) {
              this.numerosEnviado = response.data.numerosEnviado;
            } else { 
              const valor1 = this.numerosEnviado;
              const valor2 = response.data.numerosEnviado;
              this.numerosEnviado = [...Object.values(valor1), ...valor2];
            }

            if(this.numerosNaoEnviado.length == 0) {
              this.numerosNaoEnviado = response.data.numerosNaoEnviado;
            } else { 
              const valor1 = this.numerosNaoEnviado;
              const valor2 = response.data.numerosNaoEnviado;
              this.numerosNaoEnviado = [...Object.values(valor1), ...valor2];
            }
          }

          if(response.data.error) {
            this.makeToast('Oops', response.data.message, 'danger');
          }
        })
        .finally(() => {
          this.numeros = this.numeros.slice(5);

          if(this.numeros.length > 0) {
            setTimeout(() => {
              this.$store.dispatch('endLoader');
              this.addNumeros();
            }, 10000);
          } else {
            this.$store.dispatch('endLoader');
          }
        })
    }
  },
};
</script>

<style scoped>
#inseridos tr td, #inseridos tr th {
  border: 2px solid green !important;
}

#naoinseridos tr td, #naoinseridos tr th {
  border: 2px solid red !important;
}
</style>
